export type Kind = "playbook" | "policy" | "decision";
export type Status = "draft" | "current" | "needs_review" | "archived";
export type Audience = "everyone" | "core_team";

export const KINDS: Kind[] = ["playbook", "policy", "decision"];
export const STATUSES: Status[] = ["draft", "current", "needs_review", "archived"];
export const AUDIENCES: Audience[] = ["everyone", "core_team"];

export const KIND_LABEL: Record<Kind, string> = {
  playbook: "Playbook",
  policy: "Policy",
  decision: "Decision record",
};

export const STATUS_LABEL: Record<Status, string> = {
  draft: "Draft",
  current: "Current",
  needs_review: "Needs review",
  archived: "Archived",
};

export const AUDIENCE_LABEL: Record<Audience, string> = {
  everyone: "Everyone",
  core_team: "Core team",
};

/** What the index page needs. Deliberately excludes the body. */
export interface DocMeta {
  id: string;
  slug: string;
  title: string;
  summary: string;
  kind: Kind;
  status: Status;
  audience: Audience;
  team: string | null;
  read_minutes: number;
  updated_at: string;
  updated_by: string;
  /** Only present on search results. */
  snippet?: string;
}

export interface Doc extends DocMeta {
  content_json: string;
  created_at: string;
  created_by: string;
}

export interface Version {
  id: number;
  title: string;
  saved_at: string;
  saved_by: string;
}

export interface User {
  email: string;
  name: string;
  picture: string | null;
}

/** Fields a client may set. Everything else is server-owned. */
export interface DocPatch {
  title?: string;
  summary?: string;
  kind?: Kind;
  status?: Status;
  audience?: Audience;
  team?: string | null;
  content_json?: string;
  content_md?: string;
}
